import React from "react";
import "./Home.css";
import Navbar from "../../Shared/Navbar";
import Header from "../Header/Header";
import About from "../About/About";
import Resume from "../Resume/Resume";
import Portfolio from "../Portfolio/Portfolio";
import Testimonials from "../Testimonials/Testimonials";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Skills from "../Skills/Skills";
import Services from "../Services/Services";
import ClientReviews from "../../ClientReviews/ClientReviews";


const Home = () => {
  return (
    <div>
      <div className="border-group">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <Navbar />
      <Header />
      <About />
      <Skills />
      <Services />
      <Resume />
      <Portfolio />
      {/* <ClientReviews />
      <Testimonials /> */}
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
